
import { Component, OnInit } from '@angular/core';
import { StoreService } from './../../../services/store.service';
import { ApiService } from './../../../services/api.service';
import { Profil } from './../../../models/Profil';
import { CommandeService } from './../../../services/commande.service';
import { SelectItem, Message, ConfirmationService } from 'primeng/primeng';
import { CommandeBordereau } from 'src/app/models/CommandeBordereau';
import { CommandeDetail } from 'src/app/models/CommandeDetail';
import { Commande } from 'src/app/models/Commande';
import { ThrowStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { LocaliteService } from 'src/app/services/reporting/localites.service';
//import { ClientsService } from 'src/app/services/reporting/clients.service';
import { ClientsService } from 'src/app/services/reporting/clients.service';
import { ReportingVenteService } from 'src/app/services/reporting/reporting.vente.service';
import { CriteriaData } from 'src/app/models/CriteriaData';
import { ExcelService } from 'src/app/services/Excel.service';
import { OperationVenteService } from 'src/app/services/reporting/operation.vente.service';
import { OperationDualWallet } from 'src/app/models/OperationDualWallet';

@Component({
  selector: 'app-operationwallet',
  templateUrl: './operationwallet.component.html',
  styleUrls: ['./operationwallet.component.css']
})
export class OperationwalletComponent implements OnInit {

  titre = 'Opération DualWallet';
  itemId: any;
  msgs: Message[] = [];

  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();

  dataBar: any;
  dataPie: any;

  listMsisdn: SelectItem[] = [];
  listLogin: SelectItem[] = [];
  selectedPdg: string;
  selectedMsisdn: string;
  datedebut: any = new Date();
  datefin: any = new Date();

  items: any[] = [];
  montantTotal:number=0;
  nombreLignes:number=0;
  displaychargement:boolean;

  displayNewCommande : boolean;
  displayList : boolean;
  item:OperationDualWallet= new OperationDualWallet();

  constructor(private confirmationService: ConfirmationService,
    private commandeService: CommandeService,
    private datePipe: DatePipe,
    private operationVenteService: OperationVenteService,
    private clientsService: ClientsService,
    private reportingVenteService: ReportingVenteService,
    private excelService: ExcelService,
    private store: StoreService) { }

  ngOnInit() {
    //let user = this.store.getItem('user');
    console.log("this.store.isUserPartenaire==================="+this.store.isUserPartenaire);
    console.log("this.store.currentUser==================="+JSON.stringify(this.store.currentUser));
    this.loadSelectList();
    this.displayList = true;
    this.displayNewCommande = false;
  }

  async recherche() {

    if(this.selectedPdg === null || this.selectedPdg === undefined || this.selectedPdg === '') {
      //this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selection un PDG ' });
      //return;
    }
    if(this.datedebut === null || this.datedebut === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de debut !' });
      return;
    }
    if(this.datefin === null || this.datefin === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Veuillez selectionnez une date de fin !' });
      return;
    }
    let criteria: CriteriaData = new CriteriaData();
    criteria.pdg = this.selectedPdg;
    criteria.msisdn = this.selectedMsisdn;
    criteria.datedebut = this.localeDateString(this.datedebut);
    criteria.datefin = this.localeDateString(this.datefin);
    console.log(JSON.stringify(criteria));
    this.displaychargement=true;
    try {
      this.items = <any>await this.operationVenteService.findOperationDualWallet(criteria).toPromise();
    } catch (error) {
      
    }
    
    this.displaychargement=false;
    this.retour();
    //console.log('items: ', this.items);

    if(this.items ===null || this.items === undefined) {
      this.items = [];
    }
    this.montantTotal=0;
    this.items.forEach(e => {
      this.montantTotal += Number(e.quantite) * Number(e.valeurFaciale);
    });
    this.nombreLignes = this.items.length;

  }


  newComande(){
    this.displayList = false;
    this.displayNewCommande = true;
    this.item = new OperationDualWallet();
  }

  async saveCommande(){
    if(this.item === null || this.item === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Données vides !' });
      return;
    }
    if(this.item.msisdn === null || this.item.msisdn === undefined || this.item.msisdn === '') {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Le champ Numéro est obligatoire' });
      return;
    }
    if(this.item.secret === null || this.item.secret === undefined || this.item.secret === '') {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Le champ Secret est obligatoire' });
      return;
    }
    if(this.item.montant === null || this.item.montant === undefined || this.item.montant <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Le champ Montant est obligatoire' });
      return;
    }
    this.item.loginPdg = this.store.currentLogin ;
    try {
      let dataRet = <any>await this.operationVenteService.saveOperationDualWallet(this.item).toPromise();
      console.log("dataRet ==== "+JSON.stringify(dataRet));
      this.recherche();
      this.msgs = []; this.msgs.push({ severity: 'success', summary: 'Confirmation', detail: 'Opération dualwallet effectuée avec succès !' });
    } catch (error) { 
      console.log(JSON.stringify(error));
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue : ' + error });
      this.recherche();
      return;
    }
  }

  retour(){
    this.displayList = true;
    this.displayNewCommande = false;
  }

  async loadSelectList() {
    this.listLogin = [];
    if(this.store.isUserPartenaire) {
      this.listLogin.push({ label: this.store.currentNomPDG, value: this.store.currentNomPDG });
      this.selectedPdg = this.store.currentNomPDG;
    } else {
      this.listLogin.push({ label: 'PDG...', value: null });
      try {
        let dataRetourPdg = <any>await this.clientsService.findAgents().toPromise();
        for (let el of dataRetourPdg) {
          this.listLogin.push({ label: el.login, value: el.login });
        }
      } catch (error) { }
    }
    
    this.listMsisdn = [];
    this.listMsisdn.push({ label: 'Msisdn...', value: null });

    //this.listMsisdn.push({ label: 'TEST 94996012 ', value: '94996012' });

    let dataRet = <any>await this.clientsService.findByLogin2(this.store.currentNomPDG).toPromise();
    for (let el of dataRet) {
      this.listMsisdn.push({ label: el.msisdn, value: el.msisdn });
    }

  }

  async onChangePDG(event) {
    
  }


  localeDateString(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === 'string') {
      return val;
    } else {
      return this.datePipe.transform(val, "dd/MM/yyyy");
    }
  }

  localeDateString2(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === 'string') {
      return val;
    } else {
      return this.datePipe.transform(val, "dd/MM/yyyy HH:mm");
    }
  }


  async exporter() {
    if(this.items === null || this.items === undefined) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    if(this.items.length <= 0) {
      this.msgs = []; this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Aucune données trouvées !' });
      return;
    }
    let listExportXLSX = [];
    listExportXLSX = [...this.items.map(entry => ({
        "DATE OPERATION": this.localeDateString2(entry.dateOperation),  
        "PDG": entry.loginPdg,
        "MSISDN": entry.msisdn,
        "MONTANT": entry.montant,
        "ETAT": this.afficheEtat(entry.status)
      }))
    ];
    this.excelService.exportAsExcelFile(listExportXLSX, 'EXPORT');
    this.msgs = []; this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Export effectuée, ' + this.items.length + ' Ligne(s) trouvée(s)' });
  }


  afficheEtat(el){
    if(el === '200') {
      return "VALIDE";
    } else {
      return "ECHEC (" + el + ")" ;
    }
  }

}
